"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerifiableDataExchangeType = exports.InternalPresentationDefinitionV2 = exports.InternalPresentationDefinitionV1 = void 0;
const SSI_types_1 = require("./SSI.types");
class InternalPresentationDefinitionV1 {
    constructor(id, input_descriptors, format, name, purpose, submission_requirements) {
        this.id = id;
        this.input_descriptors = input_descriptors;
        this.format = format;
        this.name = name;
        this.purpose = purpose;
        this.submission_requirements = submission_requirements;
    }
    getVersion() {
        return SSI_types_1.PEVersion.v1;
    }
}
exports.InternalPresentationDefinitionV1 = InternalPresentationDefinitionV1;
class InternalPresentationDefinitionV2 {
    constructor(id, input_descriptors, format, frame, name, purpose, submission_requirements) {
        this.format = format;
        this.frame = frame;
        this.id = id;
        this.input_descriptors = input_descriptors;
        this.name = name;
        this.purpose = purpose;
        this.submission_requirements = submission_requirements;
    }
    getVersion() {
        return SSI_types_1.PEVersion.v2;
    }
}
exports.InternalPresentationDefinitionV2 = InternalPresentationDefinitionV2;
var VerifiableDataExchangeType;
(function (VerifiableDataExchangeType) {
    VerifiableDataExchangeType[VerifiableDataExchangeType["JSONLD"] = 0] = "JSONLD";
    VerifiableDataExchangeType[VerifiableDataExchangeType["JWT_ENCODED"] = 1] = "JWT_ENCODED";
    VerifiableDataExchangeType[VerifiableDataExchangeType["JWT_DECODED"] = 2] = "JWT_DECODED";
})(VerifiableDataExchangeType = exports.VerifiableDataExchangeType || (exports.VerifiableDataExchangeType = {}));
